import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dr-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss']
})
export class InputSelectComponent implements OnInit {

  public selectedNewParticipantType: any;

  public options = [
    { type: 'Option 1' },
    { type: 'Option 2' },
    { type: 'Option 3' },
    { type: 'Option 4' },
  ];

  constructor() { }

  ngOnInit() {
  }

}
